export default "__VITE_ASSET__Cf_1g$B8__"